import { withRequisitionLineKey } from "./requisitionLineIdentity";
import { requisitionQuantityError } from "./requisitionUnits";

// Shared with the original requisition form; validate the whole replacement first.
export function requisitionTemplateLines(selected, { items, suppliers, units, languageId, t }) {
  const lines = (selected?.lines || []).map((line) => withRequisitionLineKey({
    item_id: line.item_id || "",
    supplier_id: line.supplier_id || "",
    quantity: line.quantity || "",
    display_unit_level: line.display_unit_level || "unit",
    subunit2_id: line.subunit2_id || null,
    subunit2_size: line.subunit2_size || null,
    unit_id: line.unit_id || "",
    pack_size: line.pack_size || 1,
    subunit_id: line.subunit_id || "",
    unit_price: Number(line.unit_price || 0),
    last_price_info: line.last_price_info || null,
    notes: line.notes || "",
  }));
  // Validate the entire replacement before changing any current lines.
  for (const [index, line] of lines.entries()) {
    if (!line.item_id) continue;
    if (line.supplier_id && !suppliers.some((supplier) => Number(supplier.id) === Number(line.supplier_id))) {
      throw new Error(t("This supplier is inactive. Select an active supplier for new purchases."));
    }
    const item = items.find((entry) => Number(entry.id) === Number(line.item_id));
    if (!item) throw new Error(t("An item in this template is no longer available. Review the template before loading it."));
    if (line.unit_id && Number(line.unit_id) !== Number(item.unit_id)) {
      throw new Error(t("The item's purchase unit has changed. Review the template before loading it."));
    }
    const snapshot = selected.lines[index];
    const staleSnapshot = ["subunit_id", "pack_size", "subunit2_id", "subunit2_size"].some((field) => {
      if (!Object.hasOwn(snapshot, field)) return false;
      if (field === "pack_size" && !(snapshot.subunit_id ?? item.subunit_id)) return false;
      if (field === "subunit2_size" && !(snapshot.subunit2_id ?? item.subunit2_id)) return false;
      return Number(snapshot[field] || 0) !== Number(item[field] || 0);
    });
    if (staleSnapshot) throw new Error(t("The item's units or packaging have changed. Reload the requisition and review its quantities before saving."));
    Object.assign(line, { subunit_id: item.subunit_id || null, pack_size: item.pack_size || 1,
      subunit2_id: item.subunit2_id || null, subunit2_size: item.subunit2_size || null });
    const validationError = requisitionQuantityError(line, item, units, languageId, t);
    if (validationError) throw new Error(validationError);
  }
  return lines;
}
